export default __webpack_public_path__ + "static/media/8sti.989b71f2.jpg";